{
  "appName": "VynaEMR",
  "appTagline": "APAC-केंद्रित इलेक्ट्रॉनिक चिकित्सा रिकॉर्ड",
  "developedByLabel": "द्वारा विकसित",
  "loading": "लोड हो रहा है...",
  "save": "सहेजें",
  "cancel": "रद्द करें",
  "delete": "हटाएं",
  "edit": "संपादित करें",
  "create": "बनाएं",
  "search": "खोजें",
  "filter": "फ़िल्टर",
  "actions": "कार्रवाई",
  "confirm": "पुष्टि करें",
  "back": "वापस",
  "next": "अगला",
  "previous": "पिछला",
  "submit": "जमा करें",
  "reset": "रीसेट",
  "close": "बंद करें",
  "yes": "हाँ",
  "no": "नहीं",
  "ok": "ठीक है",
  "error": "त्रुटि",
  "success": "सफल",
  "warning": "चेतावनी",
  "info": "जानकारी",
  "validation": {
    "required": "यह फ़ील्ड आवश्यक है",
    "invalidEmail": "अमान्य ईमेल पता",
    "invalidPhone": "अमान्य फ़ोन नंबर",
    "invalidDate": "अमान्य तिथि",
    "minLength": "न्यूनतम {{min}} वर्ण आवश्यक हैं",
    "maxLength": "अधिकतम {{max}} वर्ण अनुमत हैं",
    "passwordMismatch": "पासवर्ड मेल नहीं खाते"
  },
  "form": {
    "fieldRequired": "{{field}} आवश्यक है",
    "selectOption": "कृपया एक विकल्प चुनें",
    "discardConfirm": "क्या असहेजे गए परिवर्तन त्यागें?",
    "unsavedChanges": "आपके पास असहेजे गए परिवर्तन हैं",
    "mustBeNonNegativeInteger": "{{field}} 0 या अधिक का पूर्ण संख्या होना चाहिए",
    "mustBeNonNegativeNumber": "{{field}} 0 या अधिक की संख्या होनी चाहिए"
  },
  "unsavedChanges": {
    "title": "असहेजे गए परिवर्तन",
    "body": "आपके पास असहेजे गए परिवर्तन हैं। क्या आप वाकई इस पृष्ठ से जाना चाहते हैं? परिवर्तन खो जाएँगे।",
    "stay": "रुकें",
    "leave": "छोड़ें"
  },
  "messages": {
    "saveSuccess": "परिवर्तन सफलतापूर्वक सहेजे गए",
    "saveError": "परिवर्तन सहेजने में विफल",
    "deleteConfirm": "क्या आप वाकई इस आइटम को हटाना चाहते हैं?",
    "deleteSuccess": "आइटम सफलतापूर्वक हटाया गया",
    "deleteError": "आइटम हटाने में विफल",
    "networkError": "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।",
    "serverError": "सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें।",
    "unauthorized": "आप यह कार्रवाई करने के लिए अधिकृत नहीं हैं।"
  },
  "dateFormat": {
    "short": "DD/MM/YYYY",
    "long": "D MMMM, YYYY",
    "withTime": "DD/MM/YYYY HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "यह VynaEMR डेमो है — कृपया वास्तविक रोगी जानकारी (PHI) दर्ज न करें।"
  },
  "network": {
    "offline": "आप ऑफ़लाइन हैं। नैदानिक डेटा सहेजा नहीं जा सकता है।"
  },
  "permissionDenied": {
    "title": "पहुँच अस्वीकृत",
    "body": "आपके पास {{action}} की अनुमति नहीं है।",
    "genericBody": "आपके पास इस संसाधन को देखने की अनुमति नहीं है।",
    "requiredPermission": "आवश्यक अनुमति: {{name}}",
    "contactAdmin": "यदि आपको लगता है कि यह त्रुटि है, तो कृपया अपने सिस्टम प्रशासक से संपर्क करें।",
    "requiresPermissionCode": "आवश्यक अनुमति: {{code}}",
    "requiresLabel": "{{label}} आवश्यक है",
    "requiresLabelWithRoles": "{{label}} आवश्यक है (धारक: {{roles}})",
    "insufficient": "अपर्याप्त अनुमतियाँ"
  },
  "skipToContent": "मुख्य सामग्री पर जाएँ",
  "openMenu": "मेनू खोलें",
  "topBar": {
    "searchPlaceholder": "रोगी खोजें (MRN, नाम, ID)...",
    "recentPatients": "हाल के रोगी",
    "searching": "खोज रहे हैं...",
    "noPatientsFound": "कोई रोगी नहीं मिला। खोजने के लिए Enter दबाएँ।",
    "notifications": "सूचनाएँ",
    "selectFacility": "सुविधा चुनें",
    "allFacilities": "सभी सुविधाएँ",
    "facilityLabel": "सुविधा {{id}}",
    "activeDepartment": "कार्यरत विभाग",
    "selectDepartment": "कार्य विभाग चुनें",
    "noDepartmentSelected": "विभाग चुनें",
    "departmentLabel": "विभाग {{id}}",
    "departmentSwitchFailed": "बदल नहीं सके"
  },
  "theme": {
    "toggle": "थीम बदलें",
    "light": "लाइट",
    "dark": "डार्क",
    "system": "सिस्टम",
    "current": "थीम: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "चालू",
  "footerHealthIssue": "कनेक्शन समस्या",
  "dobLabel": "जन्म तिथि {{date}}",
  "pagination": {
    "previous": "पिछला",
    "next": "अगला",
    "pageOf": "पृष्ठ {{current}} / {{total}}",
    "showing": "{{total}} में से {{from}} से {{to}} दिखाए जा रहे हैं",
    "loadMore": "और लोड करें"
  },
  "table": {
    "empty": "कोई डेटा नहीं",
    "loading": "लोड हो रहा है..."
  },
  "cdsAlert": {
    "severity": {
      "info": "जानकारी",
      "warning": "चेतावनी",
      "critical": "गंभीर"
    },
    "overridden": "ओवरराइड किया गया",
    "acknowledged": "स्वीकृत",
    "justificationPlaceholder": "औचित्य कारण दर्ज करें...",
    "submit": "सबमिट करें",
    "acknowledge": "स्वीकार करें",
    "override": "ओवरराइड करें",
    "regionAria": "नैदानिक निर्णय समर्थन (CDS) अलर्ट",
    "acknowledgeFailed": "स्वीकृति दर्ज नहीं हो सकी — यह सहेजी नहीं गई। कृपया पुनः प्रयास करें।",
    "overrideFailed": "ओवरराइड दर्ज नहीं हो सका — यह सहेजा नहीं गया। कृपया पुनः प्रयास करें।",
    "addressedCount_one": "{{count}} का समाधान किया गया",
    "addressedCount_other": "{{count}} का समाधान किया गया"
  },
  "components": {
    "printButton": {
      "defaultLabel": "प्रिंट करें"
    },
    "codeSearch": {
      "searchPlaceholder": "कोड खोजें...",
      "clearAriaLabel": "चयन हटाएँ",
      "noCodesFound": "कोई कोड नहीं मिला"
    },
    "demographicPicker": {
      "addPlaceholder": "जोड़ें…",
      "loading": "लोड हो रहा है…",
      "noneRecorded": "कोई रिकॉर्ड नहीं",
      "removeAriaLabel": "{{value}} हटाएँ",
      "unavailable": "मान सूची उपलब्ध नहीं",
      "unavailableHint": "मान सूची लोड नहीं हो सकी। मौजूदा मान अपरिवर्तित हैं और फिर भी सहेजे जाएंगे।",
      "uncodedBadge": "अकूटबद्ध",
      "uncodedTitle": "कूटबद्ध मान उपलब्ध होने से पहले दर्ज किया गया। इसे हटाया जा सकता है, परंतु फिर से जोड़ा नहीं जा सकता।"
    }
  },
  "pages": {
    "accessDenied": {
      "title": "एक्सेस अस्वीकृत",
      "httpStatus": "HTTP 403",
      "body": "आपके पास इस पृष्ठ को देखने की अनुमति नहीं है।",
      "attemptedLabel": "एक्सेस का प्रयास:",
      "requiredPermissionLabel": "आवश्यक अनुमति:",
      "typicallyHeldByLabel": "आमतौर पर यह अनुमति रखने वाली भूमिकाएँ:",
      "signedInAs": "साइन इन के रूप में",
      "contactAdminHelp": "यदि आप मानते हैं कि यह त्रुटि है, तो आवश्यक भूमिका के लिए अनुरोध करने हेतु अपने सिस्टम प्रशासक या विभागाध्यक्ष से संपर्क करें।",
      "goBack": "वापस",
      "dashboard": "डैशबोर्ड",
      "contact": "संपर्क"
    },
    "notificationInbox": {
      "title": "सूचनाएँ",
      "markAllRead": "सभी को पढ़ा हुआ चिह्नित करें",
      "loading": "सूचनाएँ लोड हो रही हैं…",
      "errorState": "सूचनाएँ लोड करने में विफल।",
      "emptyState": "कोई सूचना नहीं मिली।",
      "ariaFilterStatus": "स्थिति के अनुसार फ़िल्टर करें",
      "ariaFilterPriority": "प्राथमिकता के अनुसार फ़िल्टर करें",
      "ariaFilterType": "प्रकार के अनुसार फ़िल्टर करें",
      "filterStatus": {
        "all": "सभी",
        "unread": "अपठित",
        "read": "पठित"
      },
      "filterPriority": {
        "allLabel": "सभी प्राथमिकताएँ",
        "critical": "गंभीर",
        "high": "उच्च",
        "normal": "सामान्य",
        "low": "निम्न"
      },
      "filterType": {
        "allLabel": "सभी प्रकार"
      },
      "notificationType": {
        "criticalResult": "गंभीर परिणाम",
        "orderUpdate": "आदेश अद्यतन",
        "appointmentReminder": "अपॉइंटमेंट अनुस्मारक",
        "systemAlert": "सिस्टम अलर्ट",
        "cdsAlert": "क्लिनिकल निर्णय समर्थन अलर्ट",
        "result": "परीक्षण परिणाम",
        "handoffAssigned": "हैंडऑफ़"
      },
      "toasts": {
        "allMarkedRead": "सभी सूचनाएँ पढ़ी हुई चिह्नित की गईं",
        "markAllReadFailed": "सभी सूचनाओं को पढ़ा हुआ चिह्नित करने में विफल",
        "markReadFailed": "सूचना को पढ़ा हुआ चिह्नित करने में विफल"
      }
    },
    "entityResolver": {
      "invalidId": "यह लिंक मान्य नहीं है।",
      "notFound": "नहीं मिला, या आपके पास इसकी पहुँच नहीं है।"
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "लाइव अपडेट अनुपलब्ध",
    "body": "कनेक्शन बहाल होने तक नए परिणाम और अलर्ट स्वतः नहीं आएंगे।",
    "authBody": "आपका सत्र समाप्त हो गया है। लाइव अपडेट बहाल करने के लिए पुनः लॉग इन करें।",
    "retry": "पुनः प्रयास",
    "login": "लॉग इन"
  }
}
